import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { UtilsService } from 'src/app/shared/utils.service';
import { PageEvent } from '@angular/material/paginator';
import { FormGroup, FormControl } from '@angular/forms';
import { Promotion } from 'src/app/super-admin/promotion.model';
import { MatDialog } from '@angular/material/dialog';
import { DataService } from 'src/app/shared/data.service';
import { AuthService } from 'src/app/auth/auth.service';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { BuySponsorComponent } from './buy-sponsor/buy-sponsor.component';
import { SendSponsoringEmailComponent } from './send-sponsoring-email/send-sponsoring-email.component';
import { ExportService } from '../../shared/export.service';

@Component({
    selector: 'app-sponsoring',
    templateUrl: './sponsoring.component.html',
    styleUrls: ['./sponsoring.component.scss'],
    standalone: false
})
export class SponsoringComponent implements OnInit {
  pageEvent!: PageEvent;
  searchForm!: FormGroup;
  showSearch: boolean;
  pageSize = 10;
  pageNumber = 1;
  totalSize = 0;
  userID: number;
  userType: number;
  promotionsList = new Array<Promotion>();
  queryParams: {
    pageNumber: number;
    pageSize: number;
    searchValue: string | null;
    isUsed: string;
  } = {
    pageNumber: 0,
    pageSize: 0,
    searchValue: null,
    isUsed: ''
  };

  searchValue = "";
  showSelect = false;
  selectAll = false;
  allSelected = false;
  selectedCodes = new Array<any>();
  selected = 'false';

  constructor(public dialog: MatDialog, public utils: UtilsService,
              public dataService: DataService,
              private authService: AuthService,
              private route: ActivatedRoute,
              private cdr: ChangeDetectorRef,
              private router: Router,
              private exportService: ExportService) {
                this.showSearch = false;
                this.userID = this.authService.getUserData().id;
                this.userType = this.authService.getUserData().type;
                this.route.queryParams.subscribe((params: Params) => {
                  if (!this.isEmpty(params)) {
                    this.selected = params.isUsed ? params.isUsed : '';
                    this.pageNumber = params.pageNumber ? params.pageNumber : 1;
                    this.pageSize = params.pageSize ? params.pageSize : 10;
                    this.searchValue =  params.searchValue ? params.searchValue : "";
                  }
                  this.getPromotions();
                });
                }

  ngOnInit(): void {
    if(this.authService.getUserData().type === this.utils.userTypes.Distributor || this.authService.getUserData().type === this.utils.userTypes.DistributorChild) {
      this.utils.setTitle('Promotional Codes');
      this.utils.screenTitle.emit({firstTitle: 'Promotional Codes', firstRoute: '/sponsoring'});
    }
    else{
      this.utils.setTitle('Sponsoring');
      this.utils.screenTitle.emit({firstTitle: 'Sponsoring', firstRoute: '/sponsoring'});
    }
    this.searchForm = new FormGroup({
      sponsorSearch: new FormControl(this.searchValue),
    });

    if (this.searchValue) {
      this.showSearch = true;
    }

    this.searchForm.get('sponsorSearch')?.valueChanges.subscribe(value => {
      const newValue = (value || '').trim();
      if (newValue === '' && this.searchValue !== '') {
        setTimeout(() => this.clearSearch(), 0);
      }
    });
  }

  filterChange(value: any) {
    this.selected = value;
      this.pageNumber = 1;
      this.queryParams = {pageNumber: this.pageNumber, pageSize: this.pageSize,
        searchValue: this.searchValue, isUsed: this.selected};
      this.router.navigate(['/sponsoring'], { queryParams: this.queryParams });
  }

  openAddPromotion() {
    const dialogRef = this.dialog.open(BuySponsorComponent, {disableClose: true, width: '400px'});
    dialogRef.afterClosed().subscribe((newPromotions) => {
      if (newPromotions && newPromotions.length > 0) {
        this.totalSize = this.totalSize + newPromotions.length;
        newPromotions.forEach((element: any) => {
          this.promotionsList.unshift(element);
        });
        if (this.promotionsList.length > this.pageSize) {
          this.promotionsList.splice(this.pageSize, this.promotionsList.length = this.pageSize);
        }
      }
    });
  }

  openSendEmail(item: any) {
    const dialogRef = this.dialog.open(SendSponsoringEmailComponent,
      {disableClose: true, width: '400px', data: {codesList: [item]}});
    dialogRef.afterClosed().subscribe(() => {
      this.showSelect = false;
    });
  }

  sendEmails() {
    if (this.selectedCodes.length > 0) {
      const dialogRef = this.dialog.open(SendSponsoringEmailComponent,
        {disableClose: true, width: '400px', data: {codesList: this.selectedCodes}});
      dialogRef.afterClosed().subscribe(() => {
      this.showSelect = false;
    });
    }
  }

  toggleSelect() {
    this.selectedCodes = [];
    this.setAll(false);
    this.showSelect = !this.showSelect;
  }

  setAll(completed: boolean) {
    this.selectAll = completed;
    this.allSelected = completed;
    if (completed === true) {
      this.selectedCodes = [];
      this.promotionsList.forEach(element => {
        if(element.isUsed.toString() == 'false') {
          this.selectedCodes.unshift(element);
        }
      });
    } else {
      this.selectedCodes = [];
    }
    this.allSelected = this.selectedCodes.length === parseInt(this.pageSize.toString(), 10);
    this.selectAll = this.selectedCodes.length === parseInt(this.pageSize.toString(), 10);
  }

  onCheckChange(item: any, checked: boolean) {
    this.allSelected = false;
    if (checked === true) {
      this.selectedCodes.unshift(item);
    } else {
      const index = this.selectedCodes.indexOf(item);
      this.selectedCodes.splice(index, 1);
    }
    this.allSelected = this.selectedCodes.length === parseInt(this.pageSize.toString(), 10);
  }

  isEmpty(obj: any) {
    return Object.keys(obj).length === 0;
  }

  handlePage(e: any) {
    this.pageNumber = e.pageIndex + 1;
    this.pageSize = e.pageSize;
    this.queryParams = {pageNumber: this.pageNumber, pageSize: this.pageSize, searchValue: this.searchValue, isUsed: this.selected};
    this.router.navigate(['/sponsoring'], { queryParams: this.queryParams });
  }

  handleSearchClick() {
    if (this.showSearch && this.promotionsList.length > 0) {
      this.doSearch();
    } else {
      this.showSearch = true;
    }
  }

  doSearch() {
    let searchInput = this.searchForm.get('sponsorSearch')?.value || '';
    this.searchValue = searchInput.trim();
    this.searchForm.get('sponsorSearch')?.setValue(this.searchValue, { emitEvent: false });
    
    if (this.searchValue) {
      this.pageNumber = 1;
      this.queryParams = {pageNumber: this.pageNumber, pageSize: this.pageSize, searchValue: this.searchValue, isUsed: this.selected};
      this.router.navigate(['/sponsoring'], { queryParams: this.queryParams });
    }
  }

  clearSearch() {
    this.showSearch = !this.showSearch;
    this.searchForm.get('sponsorSearch')?.setValue('');
    this.searchValue = '';
    this.pageNumber = 1;
    this.queryParams = {
      pageNumber: this.pageNumber,
      pageSize: this.pageSize,
      searchValue: this.searchValue,
      isUsed: this.selected
    };
    this.router.navigate(['/sponsoring'], { queryParams: this.queryParams });
  }

  getPromotions() {
      this.dataService.get('promotionCode/RetrievePromotionCodeByUserId/' +
      parseInt(this.userID.toString(), 10) + '?pageNumber=' + this.pageNumber +
      '&pageSize=' + this.pageSize +
      '&searchKeyword=' + this.searchValue +
      '&isUsed=' + this.selected).then((data: any) => {
        if (data.statusCode === 200) {
          this.promotionsList = [];
          const promotionsData = data.data.records;
          this.totalSize = data.data.count;
          promotionsData.forEach((promotionData: any) => {
            const promotionInstance = new Promotion(promotionData);
            this.promotionsList.push(promotionInstance);
          });
          if (promotionsData.length === 0 && this.totalSize > 0) {
            this.pageNumber = 1;
            this.queryParams = {pageNumber: this.pageNumber, pageSize: this.pageSize, searchValue: this.searchValue, isUsed: this.selected};
            this.router.navigate(['/sponsoring'], { queryParams: this.queryParams });
          }
        }
      });
  }

  exportSponsorings(fileTypeId: number) {
    this.exportService.exportFile(`promotionCode/export/AllPromotionCodes`, fileTypeId, this.searchValue, 'manufacturerSponsorings', { isUsed: this.selected } );
  }
}
